"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var input_list_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/input_list"));
var input_store_factory_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory"));
var InputListStore = /** @class */ (function () {
    function InputListStore(props) {
        var _this = this;
        var _a;
        this.component = input_list_1.default;
        this.observeValueChanged = function (fn) {
            _this.inputStores.forEach(function (input) { return input.observeValueChanged(fn); });
        };
        this.findInputStoreByRawName = function (rawName) {
            return _this.inputStores.find(function (input) { return input.rawName === rawName; });
        };
        this.replaceInputStore = function (inputProps) {
            var pos = _this.inputStores.findIndex(function (store) { return [inputProps.rawName, inputProps.name].includes(store.rawName); });
            if (pos === -1) {
                return;
            }
            _this.inputStores.splice(pos, 1, input_store_factory_1.default.createInputStore(inputProps));
        };
        /**
         * @deprecated validatorでの互換用なので使わないでください
         */
        this.getInputStores = function () {
            return _this.inputStores;
        };
        this.inputStores = ((_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.map(input_store_factory_1.default.createInputStore)) || [];
    }
    Object.defineProperty(InputListStore.prototype, "value", {
        get: function () {
            return this.inputStores.reduce(function (acc, input) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[input.rawName] = { name: input.name, value: input.value }, _a)));
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], InputListStore.prototype, "inputStores", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], InputListStore.prototype, "value", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], InputListStore.prototype, "replaceInputStore", void 0);
    return InputListStore;
}());
exports.default = InputListStore;
